import { Redirect } from 'react-router-dom';
import React from 'react';
import { arePageFlagsPending, EventSettingsContextType, useEventSettings } from '../../../lib/context-providers/event-settings-context/event-settings-context';
import SpeakerDetails from './SpeakerDetails';
import EventDetails from '../../shared/EventDetails';
import isEnabledRoute from '../../../hooks/use-enabled-route';
import { IAuthContext, useAuth } from '../../../lib/context-providers/auth-context';
import { PassportPageType } from '../../../lib/api/custom-page.types';
import { ROOT } from '../../../config/routes/paths';
import { usePathPrefix } from '../../../hooks/use-path-prefix';
import { normalizeRoutePath } from '../../../lib/helpers/urlHelper';

const SpeakerWrapper = (): JSX.Element | null => {
  const auth = useAuth() as IAuthContext;
  const isAuthenticated = !!auth.isAuthenticated;
  const isLoading = auth.isLoading;
  const pathPrefix = usePathPrefix();

  const eventData = useEventSettings() as EventSettingsContextType;
  const enabledRoute = isEnabledRoute(eventData?.landingPage);

  if (!eventData || isLoading || arePageFlagsPending(eventData)) return null;

  const pageConfiguration = eventData.customPages?.find(el => el.type === PassportPageType.SPEAKERS);

  if (isAuthenticated && !eventData.speakersEnabled) {
    return <Redirect to={enabledRoute} />;
  }

  if (!isAuthenticated && !pageConfiguration?.publicEnabled) {
    return <Redirect to={normalizeRoutePath(ROOT, pathPrefix)} />;
  }

  return (
    <>
      <EventDetails details={eventData}/>
      <SpeakerDetails event={eventData} label={eventData.speakersLabel || pageConfiguration?.label} />
    </>
  );
};

export default SpeakerWrapper;
